import { render, staticRenderFns } from "./BollingerSqueeze.vue?vue&type=template&id=623dc792&scoped=true"
import script from "./BollingerSqueeze.vue?vue&type=script&lang=js"
export * from "./BollingerSqueeze.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623dc792",
  null
  
)

export default component.exports